import { DynamicPdfDataGetRequest, DynamicPdfType, Language, Theme } from '@breathelife/types';
import { AnswerPath, Localized, QuestionnaireDefinition } from '@zinnia/form-engine-sdk';

import ApiService from './ApiService';

export async function fetchDynamicPdfData(
  applicationId: string,
  dynamicPdfType: DynamicPdfType,
  language: Language,
  participantId?: string,
): Promise<DynamicPdfDataGetRequest<Localized<QuestionnaireDefinition>, AnswerPath>> {
  const insuranceProductsResponse = await ApiService.getDynamicPdfData<Localized<QuestionnaireDefinition>, AnswerPath>(
    applicationId,
    dynamicPdfType,
    language,
    participantId,
  );
  return insuranceProductsResponse.data;
}

export async function fetchTheme(options: { mgaId?: string }): Promise<Theme> {
  if (options.mgaId) {
    const response = await ApiService.fetchThemeForMga(options.mgaId);
    return response.data;
  }
  const response = await ApiService.fetchDefaultTheme();
  return response.data;
}
